import "./single-solutions-2026.scss";
import "../../../js/core";
import "../../../js/compare-slider";
import Collapse from "bootstrap/js/src/collapse";
import "../../../../assets/src/eos/js/scroll-to-anchor";

jQuery(function ($) {
  const modalEl = $("#modalResponseSent");

  function cleanBackdrops() {
    const backdrops = $(".modal-backdrop");
    if (backdrops.length > 1) {
      backdrops.not(":first").remove();
    }
  }

  $(document).on("hidden.bs.modal", ".modal", function () {
    if ($(".modal.show").length === 0) {
      $(".modal-backdrop").remove();
      $("body").removeClass("modal-open").css("padding-right", "");
    }
  });

  $(document).on("show.bs.modal", ".modal", cleanBackdrops);

  $(document).on("click", ".js-download-btn", function (e) {
    e.preventDefault();
    const $btn = $(this);
    const fileUrl = $btn.data("file-url");
    if (!fileUrl) return;

    const onclickCode = $btn.attr("onclick") || "";
    const eventLabelMatch = onclickCode.match(/'eventLabel':'([^']+)'/);
    const eventContextMatch = onclickCode.match(/'eventContext':'([^']+)'/);
    const eventPositionMatch = onclickCode.match(/'eventPosition':'([^']+)'/);

    const eventLabel = eventLabelMatch ? eventLabelMatch[1] : $btn.text().trim();
    const eventContext = eventContextMatch ? eventContextMatch[1] : $btn.text().trim();
    const eventPosition = eventPositionMatch ? eventPositionMatch[1] : "forest_solutions";

    fetch(fileUrl)
      .then((response) => {
        if (!response.ok) throw new Error("Download failed");
        return response.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileUrl.split("/").pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        // === SUCCESS ===
        dataLayer.push({
          event: "EOSCOM",
          eventCategory: "EosComEvents",
          eventAction: "pdf_download_success",
          eventLabel: eventLabel,
          eventPosition: eventPosition,
          eventContext: eventContext,
          eventContent: "",
        });

        if (modalEl.length) {
          modalEl.find(".modal-title").text(window.downloadModalTexts?.successTitle || "");
          modalEl.find(".message").text(window.downloadModalTexts?.successMessage || "");
          modalEl.addClass("mail_sent");

          setTimeout(() => {
            cleanBackdrops();
            modalEl.modal("show");
          }, 3500);
        }
      })
      .catch(() => {
        // === ERROR ===
        dataLayer.push({
          event: "EOSCOM",
          eventCategory: "EosComEvents",
          eventAction: "pdf_download_error",
          eventLabel: eventLabel,
          eventPosition: eventPosition,
          eventContext: eventContext,
          eventContent: "",
        });

        if (modalEl.length) {
          modalEl.find(".modal-title").text(window.downloadModalTexts?.errorTitle || "");
          modalEl.find(".message").text(window.downloadModalTexts?.errorMessage || "");
          modalEl.removeClass("mail_sent");

          setTimeout(() => {
            cleanBackdrops();
            modalEl.modal("show");
          }, 4500);
        }
      });
  });
});
